import { ChangeEvent, useEffect, useState } from "react";

import { usePinProjects } from "../mutations";
import { useFilterContext, FilterItem } from "../../../shared/context/FilterContext";
import { useProjects } from "./useProjects";
import { useStages } from "./useStages";
import { stageGateApi } from "../../stageGates/api/service";
import { useQuery } from "@tanstack/react-query";
import { coamAreaApi } from "../../geospatial/api/coamArea";
import { extractFilterValues } from "../../../lib/filterUtils";

export const useFetchProjects = (isPinned: boolean, isCompleted: boolean, portfolioId: string | undefined, options: { my_tasks: boolean }) => {

    const pinProjects = usePinProjects();
 

    const { tempFilters, quickFilters, handleUpdateTempFilters, handleResetFilters, handleApplyFilters } = useFilterContext();

    const [searchDraft, setSearchDraft] = useState<string>('');
    const [searchKey, setSearchKey] = useState<string>('');

    const [page, setPage] = useState<number>(1);
    const [limit, setLimit] = useState<number>(25);

    const [status, setStatus] = useState<{
        id: number | null;
        name: string | null
    }>({
        id: null,
        name: null
    });

    const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);

    const { stagesData, isLoading: isStageLoading, isError: isStageError, refetch: refetchStages, removeCachePinned: removeCachePinnedStages, removeCacheUnpinned: removeCacheUnpinnedStages,removeCache : removeCachestages } = useStages({
        searchKey,
        portfolioId,
        isPinned,
        isCompleted,
        quickFilters: {
            region: extractFilterValues(quickFilters.region) ?? null,
            programme: extractFilterValues(quickFilters.programme) ?? null,
            site: extractFilterValues(quickFilters.site) ?? null,
            workstream: extractFilterValues(quickFilters.workstream) ?? null,
            'worktype-group': extractFilterValues(quickFilters['worktype-group']) ?? null,
            projectYear: extractFilterValues(quickFilters.projectYear) ?? null,
            my_tasks : options.my_tasks,
            stakeholder: extractFilterValues(quickFilters.stakeholder) ?? null
        },
        page, limit
    });

    const { projectData, isLoading: isProjectLoading, isError: isProjectError, pagination, refetch: refetchProjects, removeCachePinned: removeCachePinnedProjects, removeCacheUnpinned: removeCacheUnpinnedProjects,removeCache : removeCacheProjects } = useProjects({
        searchKey,
        portfolioId,
        isPinned,
        isCompleted,
        quickFilters: {
            region: extractFilterValues(quickFilters.region) ?? null,
            programme: extractFilterValues(quickFilters.programme) ?? null,
            site: extractFilterValues(quickFilters.site) ?? null,
            workstream: extractFilterValues(quickFilters.workstream) ?? null,
           'worktype-group': extractFilterValues(quickFilters['worktype-group']) ?? null,
            projectYear: extractFilterValues(quickFilters.projectYear) ?? null,
            stakeholder: extractFilterValues(quickFilters.stakeholder) ?? null
        },
        phase_name: status.name,
        phase_type_id: status.id,
        page, limit,
        my_tasks: options.my_tasks,
    });

    useQuery({
        queryKey: ["project",  options.my_tasks,  page, limit],
        queryFn: () => coamAreaApi.fetchProjects({
             page, limit,
            my_tasks: options.my_tasks,
            phase_name: status.name ?? undefined,
            phase_type_id: status.id ?? undefined,
           }),
        
    });

    const handleOpenFilter = () => {
        setIsOpenFilter(true);
    };

    const handleCloseFilter = () => {
        setIsOpenFilter(false);
        const isDifferent = JSON.stringify(tempFilters) !== JSON.stringify(quickFilters);
        if (isDifferent) {
            handleApplyFilters();
        }
    };

    const handleChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchDraft(e.target.value);
    };

    const handleClear = () => {
        setSearchDraft('');
        setSearchKey('');
    };

    const handleSearch = () => {
        setSearchKey(searchDraft);
    };

    const changePage = (page: number) => {
        setPage(page);
    };

    const changeRowsPerPage = (limit: number) => {
        setLimit(limit);
    };

    

    const handlePinProject = async (id: string, status: boolean) => {
        await pinProjects.mutateAsync({ id: id, status: status });
        removeCachePinnedProjects();
        removeCacheUnpinnedProjects();
        removeCachePinnedStages();
        removeCacheUnpinnedStages();
    };

    useEffect(() => {
        const allPhaseStage = stagesData.find(
            (stage: { name: string; id: any }) => stage.name === 'All Phase'
        );
        if (allPhaseStage) {
            setStatus({
                id: allPhaseStage.id,
                name: allPhaseStage.name
            });
        }
    }, [stagesData, isStageLoading]);

    

    return {
        pagination,
        isLoading: isProjectLoading || isStageLoading,
        isError: isProjectError,
        searchDraft,
        projects: projectData,
        projectStages: stagesData || [],
        status, setStatus,
        handleChangeSearch, handleClear, handleSearch, changePage, changeRowsPerPage,
        handleUpdateTempFilters,
        handleResetFilters,
        handleApplyFilters,
        tempFilters,
        isOpenFilter, handleOpenFilter, handleCloseFilter,
        handlePinProject,
        refetchProjects, refetchStages,
        removeCachePinnedProjects, removeCacheUnpinnedProjects,
        removeCachePinnedStages, removeCacheUnpinnedStages,
        removeCacheProjects, removeCachestages,
      

    };

};